import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const KEY_CHALLENGES: ComboBoxItem<string>[] = [
  {
    id: 0,
    label: "High Cost of Model Deployment",
    value: "High Cost of Model Deployment",
  },
  {
    id: 1,
    label: "Limited Technical Expertise",
    value: "Limited Technical Expertise",
  },
  {
    id: 3,
    label: "Lack of Scalable Infrastructure",
    value: "Lack of Scalable Infrastructure",
  },
  {
    id: 4,
    label: "Integration with Existing Systems",
    value: "Integration with Existing Systems",
  },
  {
    id: 5,
    label: "Ensuring Model Accuracy and Reliability",
    value: "Ensuring Model Accuracy and Reliability",
  },
  {
    id: 6,
    label: "Compliance with Regulatory Standards",
    value: "Compliance with Regulatory Standards",
  },
  {
    id: 7,
    label: "Data Privacy and Security Concerns",
    value: "Data Privacy and Security Concerns",
  },
  {
    id: 8,
    label: "Monitoring and Maintaining Deployed Models",
    value: "Monitoring and Maintaining Deployed Models",
  },
  {
    id: 9,
    label: "Difficulty in Meeting Business ROI Goals",
    value: "Difficulty in Meeting Business ROI Goals",
  },
  { id: 10, label: "Slow Deployment Speed", value: "Slow Deployment Speed" },
  {
    id: 11,
    label: "Handling Large-Scale Traffic or Data",
    value: "Handling Large-Scale Traffic or Data",
  },
  {
    id: 12,
    label: "Poor Collaboration Between Teams",
    value: "Poor Collaboration Between Teams",
  },
  {
    id: 13,
    label: "Limited Budget for Advanced Tools",
    value: "Limited Budget for Advanced Tools",
  },
  {
    id: 14,
    label: "Difficulty in Explaining AI Outcomes (Black Box Models)",
    value: "Difficulty in Explaining AI Outcomes (Black Box Models)",
  },
  {
    id: 15,
    label: "Adapting Models to Dynamic or Changing Environments",
    value: "Adapting Models to Dynamic or Changing Environments",
  },
  {
    id: 16,
    label: "Difficulty in Transitioning from Prototype to Production",
    value: "Difficulty in Transitioning from Prototype to Production",
  },
  {
    id: 17,
    label: "Limited Time to Focus on Deployment",
    value: "Limited Time to Focus on Deployment",
  },
  {
    id: 18,
    label: "Low User Adoption of AI-Powered Solutions",
    value: "Low User Adoption of AI-Powered Solutions",
  },
  {
    id: 19,
    label: "Others",
    value: "Others",
  },
];

export default KEY_CHALLENGES;
